function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51.85 39.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M37.55,20.71a7.17,7.17,0,1,0-7.17-7.17A7.17,7.17,0,0,0,37.55,20.71Zm0-10.33a3.17,3.17,0,1,1-3.17,3.16A3.17,3.17,0,0,1,37.55,10.38Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.85,0H9A9,9,0,0,0,0,9V30.44a9,9,0,0,0,9,9H42.85a9,9,0,0,0,9-9V9A9,9,0,0,0,42.85,0ZM9,4H42.85a5,5,0,0,1,5,5V30.44a5,5,0,0,1-.1,1L42,25.6a9,9,0,0,0-12.73,0L27.84,27l-8.43-8.43a9,9,0,0,0-12.73,0L4,21.24V9A5,5,0,0,1,9,4ZM4,30.44V26.9l5.51-5.51a5,5,0,0,1,7.07,0l14.06,14H9A5,5,0,0,1,4,30.44Zm32.29,5-5.62-5.63,1.38-1.38a5,5,0,0,1,7.07,0l6.28,6.28a4.86,4.86,0,0,1-2.55.73Z",
    style: {
      fill: "currentColor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.83020104.svg";
export { ForwardRef as ReactComponent };